import { render, staticRenderFns } from "./CompareTwoCards.vue?vue&type=template&id=65af8d3e&scoped=true&"
import script from "./CompareTwoCards.vue?vue&type=script&lang=js&"
export * from "./CompareTwoCards.vue?vue&type=script&lang=js&"
import style0 from "./CompareTwoCards.vue?vue&type=style&index=0&id=65af8d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af8d3e",
  null
  
)

export default component.exports